import { Typography, Link } from "@mui/material";
import WarningAmberOutlinedIcon from "@mui/icons-material/WarningAmberOutlined";
import { UITooltip } from "../../../../components/UITooltip";

interface VersionWarningTooltipProps {
  isAllowed: boolean;
}

export const VersionWarningTooltip = ({
  isAllowed,
}: VersionWarningTooltipProps) => {
  if (isAllowed) return null;

  return (
    <UITooltip
      title={
        <Typography variant="body2">
          Your current managed package is not compatible with this data type.
          Please upgrade your package{" "}
          <Link
            href="https://appexchange.salesforce.com/appxListingDetail?listingId=a0N3A00000EXnknUAD&tab=e"
            target="_blank"
            rel="noopener noreferrer"
            sx={{ color: "primary.main" }}
          >
            here
          </Link>
        </Typography>
      }
    >
      <WarningAmberOutlinedIcon
        sx={{ color: "warning.main", fontSize: 20, ml: 0.5 }}
      />
    </UITooltip>
  );
};
